export default {
  smallest: '0.25rem',
  small: '0.5rem',
  regular: '1rem',
  large: '2rem',
  largest: '4rem'
}



// WEBPACK FOOTER //
// ./src/styles/spaces.js